import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./auth_provider";
import AppConfig from "./appConfig";

const PrivateRoute = () => {
  const user = useAuth();
  // if (!user.token) {
  if (!localStorage.getItem(AppConfig.auth_token)) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

export default PrivateRoute;
